import TYPES from './types';
import cloudApi from '../../api/cloudApi';

export const getRewards = brandId => (dispatch, getState) => {
  return dispatch({
    type: TYPES.GET_REWARDS,
    payload: cloudApi.getRewards(brandId)
  });
};
